import React from 'react';
import PropTypes from "prop-types";
import {OutlineErrorIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import styles from './InvalidBillTypeMessage.module.scss';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

export const InvalidBillTypeMessageContent = (props) => {
  const {message, title, Icon = OutlineErrorIcon, onClose} = props;

  return (
    <div className={styles.container}>
      <div className="text-center mb-0 lg:mb-3"><Icon stroke="#FFB350"/></div>
      <div className="pb-2 lg:pb-0">
        <h3 className={clsx("text-lg text-center lg:pt-1 pb-1", styles.title)}>{title}</h3>
        <p className={clsx("text-center pb-8", styles.message)}>{message}</p>
      </div>

      <div className="text-center">
        <Button label="Aceptar" onClick={onClose}/>
      </div>
    </div>
  );
};

InvalidBillTypeMessageContent.defaultProps = {
  title: '¡Adjunte otra factura!',
  message: 'El servicio de auto inscripción no está disponible para el tipo de vehículo especificado en la factura.',
  onClose: emptyFn,
};

InvalidBillTypeMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default React.memo(InvalidBillTypeMessageContent);
